import { ActionTypes } from './actionTypes';

export const fetchUserSettingsInit = () => ({
  type: ActionTypes.FETCH_USER_SETTINGS_INIT,
});

export const fetchUserSettingsSuccess = (payload: any) => ({
  type: ActionTypes.FETCH_USER_SETTINGS_SUCCESS,
  payload,
});

export const fetchUserSettingsFailure = (error: any) => ({
  type: ActionTypes.FETCH_USER_SETTINGS_FAILURE,
  payload: error,
});